export default "__VITE_ASSET__59L3$sjY__"